import { useEffect } from "react";
import { getAudio } from "@/audio";

export const useTronHum = (on) => {
  useEffect(() => {
    if (!on) return;
    const { ctx, out } = getAudio();
    const t = ctx.currentTime;
    const bus = ctx.createGain();
    bus.gain.setValueAtTime(0, t);
    bus.gain.linearRampToValueAtTime(0.06, t + 2.5);
    const lp = ctx.createBiquadFilter();
    lp.type = "lowpass";
    lp.frequency.value = 520;
    lp.Q.value = 6;
    lp.connect(bus).connect(out);
    const sweep = ctx.createOscillator();
    const sweepAmt = ctx.createGain();
    sweep.frequency.value = 0.18;
    sweepAmt.gain.value = 220;
    sweep.connect(sweepAmt).connect(lp.frequency);
    const pulse = ctx.createOscillator();
    const pulseAmt = ctx.createGain();
    pulse.frequency.value = 6;
    pulseAmt.gain.value = 0.25;
    const pulseGain = ctx.createGain();
    pulseGain.gain.value = 0.75;
    pulse.connect(pulseAmt).connect(pulseGain.gain);
    pulseGain.connect(lp);
    const oscs = [[55, "sawtooth", -8], [55, "sawtooth", 8], [110, "square", 0], [82.41, "triangle", 0]].map(([f, type, det]) => {
      const o = ctx.createOscillator();
      o.type = type;
      o.frequency.value = f;
      o.detune.value = det;
      o.connect(pulseGain);
      o.start(t);
      return o;
    });
    [sweep, pulse].forEach((o) => o.start(t));
    window.__tronHum = true;
    return () => {
      window.__tronHum = false;
      bus.gain.cancelScheduledValues(ctx.currentTime);
      bus.gain.setTargetAtTime(0, ctx.currentTime, 0.4);
      setTimeout(() => { [...oscs, sweep, pulse].forEach((o) => { try { o.stop(); } catch { /* stopped */ } }); bus.disconnect(); }, 2500);
    };
  }, [on]);
};
